import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { environment } from '../../../environments/environment';

import { PortalLetterModel } from '../../shared/models/mail/portal-letter.model';

@Injectable({
	providedIn: 'root'
})
export class MailService {
	public unreadLetterCount = new EventEmitter<number>();

	constructor(private httpClient: HttpClient) {}

	public getNoticeCountSinceLastAccess(): void {
		this.httpClient
			.get<number>(environment.apiUrl + 'api/Portal/GetNoticeCountSinceLastAccess')
			.subscribe((data) => {
				this.unreadLetterCount.emit(data);
			});
	}

	public getNoticesForPortalAccount(): Observable<PortalLetterModel[]> {
		return this.httpClient.get<PortalLetterModel[]>(environment.apiUrl + 'api/Portal/GetNoticesForPortalAccount');
	}

	public loadNotice(path: string): Promise<any> {
		return this.httpClient
			.get(environment.apiUrl + `api/Portal/DownloadNotice?path=${encodeURI(path)}`, {
				responseType: 'arraybuffer'
			})
			.toPromise();
	}

	public updateNoticeAccessDate(): Observable<any> {
		return this.httpClient.post<any>(environment.apiUrl + 'api/Portal/UpdateLetterAccessDate', null);
	}
}
